import { ExternalLink } from "lucide-react";

export const NASASpotStation = ({ url }) => (
  <div className="glass-card p-6">
    <h2 className="section-title mb-4">Find Visible Passes</h2>
    <p className="text-slate-400 mb-6">
      NASA's Spot the Station service provides precise times when the ISS will be visible 
      from your location. Sign up for alerts to never miss a sighting opportunity.
    </p>
    <a
      href={url || "https://www.nasa.gov/spot-the-station/"}
      target="_blank"
      rel="noopener noreferrer"
      className="btn-primary inline-flex items-center gap-2"
      data-testid="nasa-spot-station-link"
    >
      <ExternalLink className="w-4 h-4" strokeWidth={1.5} />
      NASA Spot the Station
    </a>
  </div>
);
